<template>
	<div class="login-box" @keydown.enter="keydownMethod">
		<div class="login-content">
			<div class="login-left">
				<img src="../../assets/pic_login_bg@2x.png">
			</div>
			<div class="login-right">
				<div class="login-form" v-if="step===1">
					<div class="login-title">
						欢迎登录<br>
						<span>
							河北省司法鉴定委托受理案件管理系统
						</span><br>
						<span>
							委托录入
						</span>
					</div>
					<div class="login-input">
						<el-select v-model="value" filterable placeholder="请选择">
							<el-option v-for="(item,index) in options" :key="index" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
					<div class="login-input">
						<el-input v-model="username" placeholder="请输入登录账号(姓名)"></el-input>
					</div>
					<div class="login-input">
						<el-input v-model="password" placeholder="请输入登录密码" show-password></el-input>
					</div>
					<div class="login-input">
						<el-input v-model="identity" placeholder="请输入身份证号"></el-input>
					</div>
					<div class="login-button">
						<el-button type="button" :loading="noRepeat" @click="getRealQRCode">立即登录</el-button>
					</div>
					<div class="login-support">
						<div>技术支持：北京中经天平科技有限公司</div>
						<!-- <a href="">京公网安备11000002000001号</a> -->
						<a href="https://beian.miit.gov.cn/">冀ICP备2021002114号-1</a>
						<a href="">©2021 河北司法鉴定协会</a>
					</div>
				</div>
				<div class="qrcode-box" v-if="step===2">
					<div class="qrcode-title">
						人脸核验
					</div>
					<div class="qrcode-image">
						<div class="qrcode-area">
							<img :src="qrcode">
						</div>
					</div>
					<div class="qrcode-refresh" @click="getRealQRCode">
						<i class="el-icon-refresh-right"></i>
						<span>刷新二维码</span>
					</div>
					<div class="qrcode-hint">
						请使用手机微信扫描以上二维码完成身份验证<br>
						（请在3分钟内进行操作，过期自动失效）
					</div>
					<div class="qrcode-support">
						技术支持：北京中经天平科技有限公司
					</div>
				</div>
				<div class="qrcode-back" v-if="step===2" @click="prevStep">
					<i class="el-icon-back"></i>
					<span>返回上一步</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'login',
		data() {
			return {
				options: [],
				value: '',
				username: '',
				password: '',
				identity: '',
				nameError: true,
				nameErrorMsg: '',
				passError: true,
				passErrorMsg: '',
				idError: true,
				idErrorMsg: '',
				step: 1,
				qrcode: '',
				time: 0,
				noRepeat: false,
				interval: ''
			};
		},
		methods: {
			...mapMutations(['login', 'saveRouter', 'saveUserinfo', 'setRealStatus']),
			// 获取机构列表
			getOrganList() {
				this.$api.organList({}, res => {
					this.options = res.data
				})
			},
			getRealQRCode() {
				// 调用登录接口
				// if(this.noRepeat){
				// 	return
				// }
				if (this.value == '') {
					this.$message.error('请选择机构。');
					return
				}
				if (this.username == '') {
					this.$message.error('请输入账号。');
					return
				}
				if (this.password == '') {
					this.$message.error('请输入密码。');
					return
				}
				if (!this.$ver.verify_identity(this.identity)) {
					this.$message.error('请输入正确的身份证号。');
					return
				}
				this.noRepeat = true
				// this.$load.loading()
				let data = {
					organization: this.value,
					username: this.username,
					password: this.password,
					idCardNo: this.identity,
					loginType: 3
				}
				this.$api.realCode(data, res => {
					// console.log(res);
					if (res.code == 200) {
						// 下一步
						this.qrcode = res.data.ERFileurl
						this.goNext()
					} else {
						this.noRepeat = false
					}
					// window.open(res.data.url)
				})
			},
			goNext() {
				this.step = 2
				// 开启轮询，查询实名结果
				this.queryResult()
			},
			prevStep() {
				this.step = 1
				this.noRepeat = false
				clearInterval(this.interval)
			},
			queryResult() {
				// 定时，查人脸结果
				this.$message({
					message: '请于一分钟之内扫描二维码，完成人脸识别。',
					type: 'warning',
					duration: 1500
				});
				this.interval = setInterval(() => {
					this.$api.realResult({
						username: this.username,
						password: this.password,
						idCardNo: this.identity
					}, res => {
						this.time = this.time + 3
						if (res.code == 200) {
							if (res.data.isLogin || this.time >= 180) {
								// 清除定时
								clearInterval(this.interval)
								if (res.data.isLogin == 1) {
									// 保存登录态
									this.login(res.data.token)
									// 查询路由
									this.getPermission()
								} else if (res.data.isLogin == 2) {
									this.noRepeat = false
									this.$error({
										title: '校验失败',
										message: res.data.msg + ',请您点击刷新二维码以重新进行校验。',
										duration: 1500
									})
								}
							} else {
								this.noRepeat = false
								clearInterval(this.interval)
							}
						}
					})
				}, 3000)
			},
			getPermission() {
				this.$api.getPermissionRouter({}, res => {
					if (res.code == 200) {
						let navigate = res.data.menuList
						let userInfo = {
							gender: res.data.userInfo.gender,
							avatar: res.data.userInfo.headImg == null ? '' : res.data.userInfo.headImg,
							back: res.data.userInfo.idCardBack == null ? '' : res.data.userInfo.idCardBack,
							front: res.data.userInfo.idCardFront == null ? '' : res.data.userInfo.idCardFront,
							name: res.data.userInfo.realName,
							realStatus: res.data.userInfo.realNameFlag,
							identity: res.data.userInfo.idCardNo,
							org: res.data.userInfo.organNo,
							// userType: res.data.userInfo.type
						}
						this.saveUserinfo(userInfo)
						this.setRealStatus(userInfo)
						let array = [{
								path: '/real',
								name: 'real',
								component: 'real',
								meta: {
									title: '河北省司法鉴定委托受理案件管理系统-实名认证',
									name: '实名认证',
									show: false
								}
							},
							{
								path: '/forget',
								name: 'forget',
								component: 'forget',
								meta: {
									title: '河北省司法鉴定委托受理案件管理系统-忘记密码',
									name: '忘记密码',
									show: false
								}
							}
						]
						navigate = navigate.concat(array)
						this.saveRouter(navigate)
						localStorage.setItem('leftnav', JSON.stringify(navigate))
						this.$routerAdd.getRouterList(r => {
							this.$router.addRoutes(r)
							this.$notify({
								title: '成功',
								message: '登录成功，即将为您跳转。',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.noRepeat = false
									this.$router.push({
										path: '/layout'
									})
								}
							});
						})
					} else {
						this.noRepeat = false
					}
				})
			},
			keydownMethod() {
				this.getRealQRCode()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			localStorage.clear()
			this.$api.resetHeader()
			this.getOrganList()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.login-box {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0px;
		top: 0px;
		z-index: 1;
		background: #e8eaef;
		display: flex;
		justify-content: center;
		align-items: center;

		.login-content {
			width: 900px;
			height: 560px;
			background: #FFFFFF;
			border-radius: 18px;
			overflow: hidden;
			display: flex;
			justify-content: space-between;

			.login-left {
				width: 272px;
				height: 100%;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.login-right {
				width: 628px;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				position: relative;

				.login-form {
					width: 400px;
					margin-left: 140px;

					.login-title {
						width: 100%;
						font-size: 22px;
						color: #464F6D;
						font-weight: bold;
						line-height: 30px;

						span {
							font-size: 18px;
						}
					}

					.login-input,
					.login-button,
					.login-support {
						width: 100%;
						height: 40px;
						margin: 15px 0px;

						.el-button {
							width: 100%;
							height: 100%;
							background: #464F6D;
							color: #FFFFFF;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 16px;
							border-radius: 4px;
							border: none;
						}

						.el-select {
							width: 260px;
						}

						.el-input {
							width: 260px;
						}
					}

					.login-button {
						width: 260px;
						margin-top: 20px;
					}

					.login-support {
						width: 440px;
						font-size: 12px;
						color: #828DA3;
						display: flex;
						justify-content: space-between;
						margin-top: 30px;
						flex-wrap: wrap;
						margin-left: -90px;
						padding: 0px 60px;
						box-sizing: border-box;

						div {
							width: 100%;
							height: 30px;
							display: flex;
							justify-content: center;
						}

						a {
							color: #828DA3;
						}

						a:hover {
							color: #007AFF;
						}
					}
				}

				.qrcode-box {
					width: 400px;

					.qrcode-title,
					.qrcode-image,
					.qrcode-refresh,
					.qrcode-hint,
					.qrcode-support {
						width: 100%;
						display: flex;
						justify-content: center;
					}

					.qrcode-title {
						height: 50px;
						color: #464F6D;
						font-size: 22px;
						font-weight: bold;
					}

					.qrcode-image {
						.qrcode-area {
							width: 160px;
							height: 160px;
							border: 1px solid #464F6D;
							box-sizing: border-box;

							img {
								width: 100%;
								height: 100%;
							}
						}
					}

					.qrcode-refresh {
						height: 50px;
						display: flex;
						justify-content: center;
						align-items: center;
						color: #0000FF;
						margin-top: 10px;
						cursor: pointer;

						i {
							margin-right: 4px;
						}

						span {
							border-bottom: 1px solid #0000FF;
							padding: 4px 0px;
						}
					}

					.qrcode-hint {
						font-size: 13px;
						color: #464F6D;
						line-height: 28px;
						text-align: center;
					}

					.qrcode-support {
						font-size: 12px;
						color: #828DA3;
						margin-top: 20px;
					}
				}

				.qrcode-back {
					position: absolute;
					right: 15px;
					bottom: 15px;
					z-index: 9;
					height: 50px;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #0000FF;
					cursor: pointer;

					i {
						font-size: 20px;
					}

					span {
						margin-left: 4px;
						padding: 4px 0px;
						border-bottom: 1px solid #0000FF;
					}
				}
			}
		}
	}
</style>
